module.exports = __webpack_public_path__ + "static/media/ALTHAR_WEB_Physician-Journeys.cff2d2df.png";